module.exports = __webpack_public_path__ + "img/MARIDAJE-NEON.141e3bc4.png";